// extracted by mini-css-extract-plugin
export default {"content":"ErpInitialView_content__2ilo1","center":"ErpInitialView_center__60Wva"};